"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logReceivedEvent = void 0;
var _logger = require("../logger");
const logReceivedEvent = event => (0, _logger.logDebug)(`Received ${event.type} event:\n\t`, event);
exports.logReceivedEvent = logReceivedEvent;